import angular from 'angular'

import ggsUtils from '../utils'
import ggsImgQueue from '../ggs-img-queue'
import ggsListSelect from '../ggs-list-select'
import ggsLineOverload from '../ggs-line-overload'
import ggsElementQuery from '../ggs-element-query'
import ggsRecalcOnevent from '../ggs-recalc-onevent'

import ggsStylerNew from '../gallery-styler-new'
import ggsGalleryRpc from '../gallery-rpc'
import ggsGalleryEmpty from '../gallery-empty'
import ggsGalleryHeader from '../gallery-header'
import ggsGalleryCampaign from '../gallery-campaign'
import ggsGalleryPreviewFlow from '../gallery-preview-flow'
import ggsGalleryModalList from '../gallery-modal-list'
import ggsGalleryModalOne from '../gallery-modal-one'
import ggsGalleryLoadMore from '../gallery-load-more'

export default angular
  .module('ggs.gallery', [
    ggsUtils,
    ggsImgQueue,
    ggsStylerNew,
    ggsListSelect,
    ggsGalleryRpc,
    ggsGalleryEmpty,
    ggsLineOverload,
    ggsElementQuery,
    ggsRecalcOnevent,
    ggsGalleryHeader,
    ggsGalleryCampaign,
    ggsGalleryPreviewFlow,
    ggsGalleryModalList,
    ggsGalleryModalOne,
    ggsGalleryLoadMore
  ])
  .name
